import handleTouch from "../../../../../common/helpers/handleTouch";
import { handleRhythmChange } from "./handleRhythmChange";
import { getBarTotalLength } from "./getBarTotalLength";
import { getRealLength } from "./getRealLength";
import { IBar, IScoreEditorThis } from "../../../../../common/types";

export const handleDotInput = async function (this: IScoreEditorThis, e: KeyboardEvent | MouseEvent | TouchEvent) {
  if (!(await handleTouch(e))) return;
  const { activeVoice } = this.state;
  const score = { ...this.state.score };
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  if (this.state.selectedNote && bars[this.state.selectedNote.bar]?.notes?.[this.state.selectedNote.note])
      return handleRhythmChange.call(this, null, true);
  let currentBarIndex = bars.length - 1;
  let currentBar = bars[currentBarIndex];
  let currentNoteIndex = currentBar.notes.length - 1;
  if (currentNoteIndex === -1) return;
  let currentNote = currentBar.notes[currentNoteIndex];
  if (currentNote.l === 16) return;
  if (currentNote.d) {
      delete currentNote.d;
      if (currentNote.t) {
          if (currentNote.l === 8) {
              score.trupletLeft! += 0.5;
          } else {
              score.trupletLeft !+= 1;
          }
      }
  } else {
      let barTotalLength = getBarTotalLength(score.signatures, currentBarIndex) * 3;
      let barLength = 0;
      if (currentBar.notes.length) {
          barLength = currentBar.notes
              .map((note, index) => getRealLength(note) * (note.t ? 2 : 3))
              .reduce((total, next) => total + next);
      }
      if (barTotalLength < barLength + (4 / currentNote.l / 2) * (currentNote.t ? 2 : 3))
          return this.setState({ fullBar: true });
      barLength += (4 / currentNote.l / 2) * (currentNote.t ? 2 : 3);
      currentNote.d = 1;
      if (currentNote.t) {
          if (currentNote.l === 8) {
              score.trupletLeft! -= 0.5;
          } else {
              score.trupletLeft! -= 1;
          }
      }
      if (barTotalLength === barLength) {
          // new bars
          bars.push({
              notes: [],
          });
      }
  }
  this.setState({ score, fullBar: false });
};
